export enum TipoCuentaBancaria {
  CuentaCorriente = 1,
  CajaAhorro = 2,
}

export enum TipoMonedaDisplay {
  USD = "Dólares",
  ARS = "Pesos",
}

export enum TipoMoneda {
  USD = "USD",
  ARS = "ARS",
}

export enum TipoFijacion {
  Manual = "Manual",
  Automatica = "Automatica",
}

export enum CondicionFinanciera {
  Activa = 0,
  InactivaTotal = 1,
  InactivaParaPagos = 2,
}

export enum BeneficiaryAccountTypes {
  external = "External",
  internal = "Internal",
}

export enum BeneficiaryAccountTypesLabel {
  external = "Externa",
  internal = "Interna",
}

export enum TransferTransactionTypeEnum {
  AUTO = "Automatica",
  MANUAL = "Manual",
}

export enum RequestTypes {
  Efectivo = 1,
  Cheque = 2,
  ECheq = 3,
  Transferencia = 4,
  TransferenciaProgramada = 5,
  OrdenDeVenta = 6,
  ContraEntrega = 7,
  ContratoFuturo = 8,
  Cupos = 9,
  TransferenciaDiferida = 10,
  ChequeRespaldo = 11,
  CuposFertilizante = 12,
  CuposCombustible = 13,
  PedidosInsumos = 14,
  IntencionCompra = 16,
  VisitaCampo = 17,

  Muestreo = 19,
  Vuelo = 20,

  SolicitudEstablecimiento = 23,
  SolicitudLote = 24,
  SolicitudMargenBruto = 25,
  SolicitudVoleo = 26
}

export enum EntityTypes {
  SolicitudContacto = 1,
  Solicitudes = 2,
  ChequesRespaldo = 3,
  SolicitudInsumos = 4,
  PedidosInsumos = 5,
  SolicitudEfectivo = 6,
  SolicitudCheque = 7,
  SolicitudECheq = 8,
  Transferencia = 9,
  TransferenciaProgramada = 10,
  OrdenVenta = 11,
  ContraEntrega = 12,
  ContratoFuturo = 13,
  Cupos = 14,
  TransferenciaDiferida = 15,
  OBJuridico = 16,
  Archivo = 17,

  IntencionCompra = 21,
  VisitaCampo = 22,
  PlanificacionProductiva = 23,

  ImpuestosBIND = 25,
  SolicitudServicio = 26,
  SolicitudMargenBruto = 27,
  SolicitudAgrobit = 29, // Solicitud de establecimiento/lote
  SolicitudVoleo = 31
}

export enum MaintenanceModules {
  General = "GENERAL",
  Granaria = "GRANARY",
  Finanzas = "FINANCIAL",
  MercadoDelDia = "DAILY_MARKET",
  Otros = "OTHER",
  Insumos = "SUPPLIES",
  Onboarding = "ONBOARDING",
  ProduccionAta = "ATA_PRODUCTION",
  ProduccionRSATYG = "RSATYG_PRODUCTION",
}

export enum MaintenanceSections {
  GeneralApp = "GENERAL_APP",
  General = "GENERAL",

  // Granaria
  Slots = "SLOTS",
  SellOrder = "SELL_ORDER",
  Sales = "SALES",
  CashOnDelivery = "CASH_ON_DELIVERY",
  FutureContracts = "FUTURE_CONTRACTS",

  // Finanzas
  Cash = "CASH",
  Check = "CHECK",
  Transfer = "TRANSFER",
  FinancialMovements = "FINANCIAL_MOVEMENTS",

  // Cotizaciones
  PriceBoard = "PRICE_BOARD",
  UnionMarket = "UNION_MARKET",

  // Insumos en proceso

  // Otros
  UserProfile = "USER_PROFILE",
  Notifications = "NOTIFICATIONS",
  Sidebar = "SIDEBAR",

  //Onboarding
  JuridicOnboarding = "JURIDIC_ONB",

  Supplies = "SUPPLIES",
}

export enum TipoInsumos {
  Fertilizante = 1,
  Combustible = 2,
  Agroquimicos = 3,
  Semillas = 4,
}

export enum LegalOnboardingStatusIds {
  Precargado = 195,
  Pendiente = 196,
  EnRevision = 197,
  RequiereCambios = 198,
  Aprobado = 199,
}

export enum LegalOnboardingDocumentStatusIds {
  Aceptado = 200,
  Rechazado = 201,
  PendienteDeAceptacion = 205,
  PEndienteDeSubida = 206,
}

export enum MeasurementUnits {
  Toneladas = 1,
  Litros = 2,
}

export const MeasurementUnitsLabel: Record<MeasurementUnits, string> = {
  [MeasurementUnits.Toneladas]: "Toneladas",
  [MeasurementUnits.Litros]: "Litros",
};

export enum ModuleTypes {
  Fertilizante = 1,
  Combustible = 2,
  Grano = 3,
}

export const ModuleTypesLabel: Record<ModuleTypes, string> = {
  [ModuleTypes.Fertilizante]: "Fertilizante",
  [ModuleTypes.Combustible]: "Combustible",
  [ModuleTypes.Grano]: "Grano",
};

export enum MotiveTypes {
  RequiereInformacion = 1,
  Rechazo = 2,
  PedidoNoEntregado = 3,
  VisitaACampo = 4,
  DesvioHectareas = 5,
  CancelacionPedidoInsumos = 6,
  CancelacionSolicitudInsumos = 7,
  BajaEstablecimiento = 8,
  BajaLote = 9,
  BajaUsuario = 10,
}

export const CodigosNotificacion = {
  // ==================== Financiera ====================
  FinancieraEfectivoDisponible: "FINANCIAL_CASH_AVAILABLE",
  FinancieraEfectivoInfoSolicitada: "FINANCIAL_CASH_INFO_REQUESTED",
  FinancieraChequeDisponible: "FINANCIAL_CHECK_AVAILABLE",
  FinancieraChequeInfoSolicitada: "FINANCIAL_CHECK_INFO_REQUESTED",
  FinancieraTransferenciaProgramadaEjecutada:
    "FINANCIAL_SCHEDULED_TRANSFER_EXECUTED",
  FinancieraTransferenciaInternaRecibida:
    "FINANCIAL_INTERNAL_TRANSFER_RECEIVED",
  FinancieraFondosACvu: "FINANCIAL_FUNDS_TO_CVU",
  FinancieraCvuDesasignado: "FINANCIAL_CVU_UNASSIGNED",
  FinancieraSaldoProyectadoNegativo: "FINANCIAL_NEGATIVE_PROJECTED_BALANCE",
  FinancieraFacturasVencidas: "FINANCIAL_INVOICES_DUE",

  // ==================== Granario ====================
  GranarioOrdenVentaConfirmada: "GRAIN_SALE_ORDER_CONFIRMED",
  GranarioOrdenVentaEnNegociacion: "GRAIN_SALE_ORDER_IN_NEGOTIATION",
  GranarioVentaFuturaConfirmada: "GRAIN_FUTURE_SALE_CONFIRMED",
  GranarioVentaFuturaEnNegociacion: "GRAIN_FUTURE_SALE_IN_NEGOTIATION",
  GranarioContraEntregaConfirmada: "GRAIN_SPOT_SALE_CONFIRMED",
  GranarioContraEntregaEnNegociacion: "GRAIN_SPOT_SALE_IN_NEGOTIATION",
  GranarioCupoAsignado: "GRAIN_QUOTA_ASSIGNED",
  GranarioUltimasEntregas: "GRAIN_LATEST_DELIVERY",
  GranarioDescargasTransito: "GRAIN_TRANSIT_UNLOAD",

  // ==================== Insumos ====================
  InsumosPedidoEntregado: "SUPPLIES_ORDER_DELIVERED",

  // ==================== Onboarding ====================
  OnboardingPjInfoSolicitada: "ONBOARDING_PJ_INFO_REQUESTED",
  OnboardingPjAprobada: "ONBOARDING_PJ_APPROVED",
};

export enum HADifferenceMotives {
  PropiasAlquiladasATerceros = 1,
  ConGanaderia = 2,
  nutilizables = 3,
  Otras = 4,
}

export enum CategoriaServicio {
  Vuelo = 1,
  Muestreo = 2,
  Voleo = 3
}

export enum UnidadCotizacionServicio {
  Hectarea = 1,
  CantidadMuestra = 2,
  Dosis = 3
}

export enum ModalidadDosisServicio {
  Fija = 1,
  Variable = 2
}

export enum TipoCampoDisplay {
  Propio = "Propio",
  Alquilado = "Alquilado",
  NoDefinido = "No definido"
}

export enum TipoOperacionSolicitudEstablecimiento {
  Alta = 1,
  Modificacion = 2,
  Baja = 3
}